import { useContext } from "react";
import { OdysseeNavigationContext } from "./context";

const useOdysseeNavigation = () => {
	return useContext(OdysseeNavigationContext);
};

export default useOdysseeNavigation;
